/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, fonts } from '@blend/consumer-components';
import { mediaBreakpoints } from '../../../common/responsive';
import { ContextualHelpListItem } from '@components/form/ContextualHelpList/ContextualHelpListItem';
import { getTextScreenDefinition } from '@components/form/ContextualHelpList/contextualHelpUtils';
import { ContextualHelpListItemModalTrigger } from '@components/form/ContextualHelpList/ContextualHelpListItemModalTrigger';

const styles = StyleSheet.create({
  footerLinkText: {
    color: colors.darkerGray,
    fontSize: 11,
    ...fonts.UntitledSans,
    textDecoration: 'underline',
    display: 'inline-block',
  },
  footerLinkWrapper: {
    paddingLeft: 16,
    paddingRight: 16,
    borderLeft: `1px solid ${colors.catalystLight30}`,
    ':first-child': {
      paddingLeft: 0,
      borderLeft: 0,
    },
    ':last-child': {
      paddingRight: 0,
    },
    [mediaBreakpoints.mobile]: {
      ':last-child': {
        borderLeft: 'none',
        display: 'block',
        paddingLeft: 0,
      },
    },
  },
});

export namespace FooterLink {
  export interface Props {
    textScreenId: string;
  }
}

export const FooterLink: React.FC<FooterLink.Props> = ({ textScreenId }) => {
  const textScreenDefinition = getTextScreenDefinition(textScreenId);
  return (
    <span className={css(styles.footerLinkWrapper)}>
      <ContextualHelpListItem
        textScreenId={textScreenId}
        textScreenDefinition={textScreenDefinition}
        renderTrigger={({ openModal }) => (
          <ContextualHelpListItemModalTrigger openModal={openModal} isInline={true}>
            <span className={css(styles.footerLinkText)}>{textScreenDefinition.linkText}</span>
          </ContextualHelpListItemModalTrigger>
        )}
      />
    </span>
  );
};
